import React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { getReviewEnabled, setReviewEnabled } from '../services/reviewSettingsService'
import { getWebpushEnabledForAll, setWebpushEnabledForAll } from '../services/pushSettingsService'
import { useToast } from '@/shared/ui/Toast'
import HomeAsLoginSetting from './HomeAsLoginSetting'
import ChartOverlaysSettings from './ChartOverlaysSettings'
import ChartThermometerSettings from './ChartThermometerSettings'
import OpportunityPublishInfoSetting from './OpportunityPublishInfoSetting'
import ExclusiveHomeLinkSetting from './ExclusiveHomeLinkSetting'
import ChartTypeSettings from './ChartTypeSettings'
import BTCWarningSettings from './BTCWarningSettings'
import ChristmasSnowSettings from './ChristmasSnowSettings'
// Gerenciar Oportunidades foi movido para a aba "Configurar Tendencias"

export default function GeneralSettings() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)
  const [pushAll, setPushAll] = React.useState(false)
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    Promise.all([getReviewEnabled(), getWebpushEnabledForAll()])
      .then(([on, push]) => {
        if (mounted) {
          setEnabled(on)
          setPushAll(push)
        }
      })
      .catch((e) =>
        toast({
          title: 'Configura����es',
          description: e?.message || 'Falha ao carregar',
          variant: 'error',
        }),
      )
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  async function handleToggle(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setReviewEnabled(next)
      setEnabled(next)
      toast({
        title: 'Revisǜo de oportunidades',
        description: next ? 'Ativada' : 'Desativada',
        variant: 'success',
        soft: true,
      })
    } catch (e: any) {
      toast({
        title: 'Revisǜo de oportunidades',
        description: e?.message || 'Falha ao salvar',
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  async function handleTogglePushAll(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setWebpushEnabledForAll(next)
      setPushAll(next)
      toast({
        title: 'Push para todos os usuǭrios',
        description: next ? 'Liberado' : 'Restrito ao master',
        variant: 'success',
        soft: true,
      })
    } catch (e: any) {
      toast({
        title: 'Push para todos os usuǭrios',
        description: e?.message || 'Falha ao salvar',
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-medium">Configura����es Gerais</h2>
      <ChartTypeSettings />
      <ChristmasSnowSettings />

      <Card>
        <CardHeader className="text-base font-semibold">Gerenciar revisǜo de oportunidades</CardHeader>
        <CardContent>
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="text-sm text-foreground/80">
                Quando ativada, novas oportunidades entram em &quot;Em Revisǜo&quot; e s�� sǜo publicadas ap��s aprova��ǜo do
                master.
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Label>Desativado</Label>
              <Switch
                checked={enabled}
                onChange={(e) => handleToggle((e.target as HTMLInputElement).checked)}
                disabled={loading || saving}
              />
              <Label>Ativado</Label>
            </div>
          </div>
        </CardContent>
      </Card>

      <HomeAsLoginSetting />
      <BTCWarningSettings />
      <ExclusiveHomeLinkSetting />

      {/* Card movido para a sessǜo Configurar Tendencias */}
      <ChartOverlaysSettings />
      <ChartThermometerSettings />
      <OpportunityPublishInfoSetting />

      <Card>
        <CardHeader className="text-base font-semibold">Notifica����es Push: libera��ǜo geral</CardHeader>
        <CardContent>
          <div className="flex items-center justify-between gap-4">
            <div className="text-sm text-foreground/80">
              Quando ativado, notifica����es push poderǜo ser habilitadas por todos os usuǭrios. No MVP, mantenha desativado
              para master�?'only.
            </div>
            <div className="flex items-center gap-2">
              <Label>Restrito ao master</Label>
              <Switch
                checked={pushAll}
                onChange={(e) => handleTogglePushAll((e.target as HTMLInputElement).checked)}
                disabled={loading || saving}
              />
              <Label>Liberado para todos</Label>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

